import styled from "styled-components"

import {spacingCss, SpacingProps} from "../global/css"

// space-evenly option omitted until it is IE compliant (https://caniuse.com/#feat=justify-content-space-evenly)
export interface FlexProps extends SpacingProps {
  inline?: boolean
  direction?: "row" | "column" | "row-reverse" | "column-reverse"
  wrap?: "nowrap" | "wrap" | "wrap-reverse"
  flex?: "initial" | "none" | "auto" | "inherit" | "unset" | string
  justifyContent?: "flex-start" | "flex-end" | "center" | "space-around" | "space-between"
  alignItems?: "stretch" | "baseline" | "center" | "flex-start" | "flex-end"
  alignContent?: "stretch" | "center" | "flex-start" | "flex-end" | "space-around" | "space-between"
  alignSelf?: "stretch" | "center" | "flex-start" | "flex-end" | "baseline" | "initial" | "inherit"
  height?: string
  width?: string
  maxHeight?: string
  minHeight?: string
  maxWidth?: string
  minWidth?: string
  position?: "static" | "relative" | "absolute" | "sticky" | "fixed"
  top?: string
  right?: string
  bottom?: string
  left?: string
}

const Flex = styled.div<FlexProps>`
  display: flex;
  ${({inline}) => inline && "display: inline-flex;"}
  ${({direction}) => direction && `flex-direction: ${direction};`}
  ${({flex}) => flex && `flex: ${flex};`}
  ${({wrap}) => wrap && `flex-wrap: ${wrap};`}
  ${({justifyContent}) => justifyContent && `justify-content: ${justifyContent};`}
  ${({alignItems}) => alignItems && `align-items: ${alignItems};`}
  ${({alignContent}) => alignContent && `align-content: ${alignContent};`}
  ${({alignSelf}) => alignSelf && `align-self: ${alignSelf};`}

  ${({maxHeight}) => maxHeight && `max-height: ${maxHeight};`}
  ${({minHeight}) => minHeight && `min-height: ${minHeight};`}
  ${({maxWidth}) => maxWidth && `max-width: ${maxWidth};`}
  ${({minWidth}) => minWidth && `min-width: ${minWidth};`}
  ${({height}) => height && `height: ${height};`}
  ${({width}) => width && `width: ${width};`}

  ${({position}) => position && `position: ${position};`}
  ${({top}) => top && `top: ${top};`}
  ${({left}) => left && `left: ${left};`}
  ${({bottom}) => bottom && `bottom: ${bottom};`}
  ${({right}) => right && `right: ${right};`}

  ${spacingCss}
`

export default Flex
